module.exports = __webpack_public_path__ + "img/chat_background.99a36524.png";